import { useCardCustomizationLang } from './useCardCustomizationLang';

export function useCardCustomization() {
  const lang = useCardCustomizationLang();
  return {
    lang,
  };
}
